/**
 * Tarifs autorisés par séance (page « Tarifs autorisés » du back-office, Maison Monday 03/11/2026).
 *
 * La fiche cours reçoit `AllowedServiceNames` (null : tous les crédits) et ne propose que les crédits dont le nom y
 * figure. Le serveur refait le même contrôle à la réservation (ServiceRestrictions::assertAllowed), cette liste n'est
 * donc qu'un confort d'affichage. Même normalisation que ServiceRestrictions::normalize côté PHP.
 */
export function normalizeServiceName(name: string): string {
  return name
    .replace(/[–—‑−]/g, '-')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .trim();
}

export function filterAllowedServices<T extends { Name: string }>(
  services: T[],
  allowedNames: string[] | null | undefined,
): T[] {
  if (!allowedNames) return services;
  const allowed = new Set(allowedNames.map(normalizeServiceName));
  return services.filter((service) => allowed.has(normalizeServiceName(service.Name ?? '')));
}
